import { Descriptions } from "antd";
import { FormattedMessage } from "react-intl";

import { BillingDescriptionProps } from "./types";

const BillingDescription: React.FC<BillingDescriptionProps> = ({
  firstName,
  lastName,
  email,
  phoneNumber,
  customerNotes,
}) => (
  <Descriptions bordered column={1}>
    <Descriptions.Item label={<FormattedMessage defaultMessage="First Name" />}>
      {firstName}
    </Descriptions.Item>
    <Descriptions.Item label={<FormattedMessage defaultMessage="Last Name" />}>
      {lastName}
    </Descriptions.Item>
    <Descriptions.Item label={<FormattedMessage defaultMessage="Email" />}>
      {email}
    </Descriptions.Item>
    <Descriptions.Item
      label={<FormattedMessage defaultMessage="Phone Number" />}
    >
      {phoneNumber}
    </Descriptions.Item>
    <Descriptions.Item label={<FormattedMessage defaultMessage="Comment" />}>
      {customerNotes}
    </Descriptions.Item>
  </Descriptions>
);

export default BillingDescription;
